import { registerSaga } from 'utils/modules/saga';

import logoutRootSaga from './sagas';

registerSaga(logoutRootSaga);

export { Logout as default } from './Logout';
export * from './actions';
